import { CalculatorFormData } from 'apps/calculator/types';

export const CALCULATE_SAVINGS = 'CALCULATE_SAVINGS';

export const calculateSavings = (calculatorFormData: CalculatorFormData) => ({
  type: CALCULATE_SAVINGS,
  calculatorFormData,
});
